import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-ink py-16 sm:py-20" aria-labelledby="faq" data-id="element-52" data-mp="1lbiqykv2vnor">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-53" data-mp="1l9fqf6wauc5s">
        <p className="font-display text-sm font-bold uppercase tracking-[0.28em] text-leaf" data-id="element-54" data-mp="1ge0g2oxi2ye4">
          ❓ Preguntas frecuentes
        </p>
        <h2 id="faq" className="mt-4 font-display text-3xl font-extrabold text-cream sm:text-4xl" data-id="element-55" data-mp="2dy3k9qv469uy">
          Lo que suelen preguntar antes de entrar
        </h2>

        <ul className="mt-9 divide-y divide-ink-600 border-y border-ink-600" data-id="element-56" data-mp="244cw6n2wg1fs">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.q} data-id="element-57" data-mp="soejm98iix9t" data-mpi={index}>
                <h3 data-id="element-58" data-mp="no0asoz37jaq">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left transition-colors duration-150 ease-out hover:text-leaf focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-leaf" data-id="element-59" data-mp="nnig3ws2pd4x">
                    <span className="font-display text-lg font-bold text-cream" data-id="element-60" data-mp="6qwwifcvfc2f">
                      {faq.q}
                    </span>
                    <PlusIcon className={`mt-1 h-5 w-5 shrink-0 text-leaf transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-61" data-mp="bjq0v24fgidz" />
                  </button>
                </h3>
                {isOpen && <p id={`faq-panel-${index}`} className="max-w-2xl pb-6 text-[15px] leading-relaxed text-cream/70" data-id="element-62" data-mp="3o039u78e09au">
                    {faq.a}
                  </p>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}